import fsmMakePick from '../fsm/make_pick';
import makedPickRemove from './maked_pick_remove';
import openModal from './open_modal';
import renderCards from './render_cards';
import search from './search';
import selectionsRemaining from './selections_remaining';
import submitDisabling from './submit_disabling';

const makePick = function($container) {
  const container = $container || $('body');
  const $form = container.find($('@makePickForm'));
  const $checkbox = $form.find($(':checkbox'));
  const $formUrl = $form.data('url');
  const $maxItems = $form.data('maxItems');
  const $modalSubmit = container.find($('@modalSubmitPick'));
  const $submit = $form.find($('@makePickSubmit'));

  const pickOverloaded = () => $form.find(':checked').length === $maxItems + 1;

  const state = () => {
    const $length = $form.find(':checked').length;
    const pickCompleted = () => ($length >= $maxItems ? $maxItems : $length === $maxItems);

    if (pickCompleted()) {
      return 'completed';
    }
    return 'inProgress';
  };

  const init = () => {
    fsmMakePick.set(state());

    submitDisabling($submit);
    selectionsRemaining(container, $maxItems);
    search();
  };

  $form.change((e) => {
    init();
    if (!pickOverloaded()) {
      const $data = $form.serialize();
      renderCards($formUrl, $data);
    }
  });

  $form.ready((e) => {
    init();
    makedPickRemove($('@makedPicks'), $form);
  });

  $checkbox.on('click', function() {
    const $this = $(this);
    const $searchField = container.find($('@focus'));
    $searchField.val('').trigger('change');

    const shake = () => {
      const $checked = $form.find(':checked').parent($('label'));
      $checked.removeClass('animated shake');
      setTimeout(() => {
        $checked.addClass('animated shake');
      }, 1);
    };

    if (pickOverloaded()) {
      $this.prop('checked', false);
      shake();
    }
  });

  init();

  fsmMakePick.observe({
    onCompleted() { openModal(); },
  });

  $modalSubmit.on('click', (e) => {
    e.preventDefault();
    $form.submit();
  });
};

export default makePick;
